import { FDCDisciplines } from '../../../cimsPage/instances/fdc'
import { CreateViewEditSoftRemoveRestore } from '../../common'

const disciplines = CreateViewEditSoftRemoveRestore({
  page: FDCDisciplines,
  object: 'Discipline',
  view: '36F7B0F7-DC87-45AD-BDB6-C204B0A579AF',
  create: '3AEEE96D-8C08-4D94-A255-286443F8B361',
  edit: 'D4B18AC6-E0CC-4308-908F-8D1C6639EBF8',
  removeRestore: '6C7C1214-42DA-422D-8007-78232864161D',
})

export const ViewFDCDiscipline = disciplines.View
export const CreateFDCDiscipline = disciplines.Create
export const EditFDCDiscipline = disciplines.Edit
export const RemoveRestoreFDCDiscipline = disciplines.RemoveRestore

export type FDCDisciplinePermission =
  | typeof ViewFDCDiscipline
  | typeof CreateFDCDiscipline
  | typeof EditFDCDiscipline
  | typeof RemoveRestoreFDCDiscipline
